/*
* @Author: Alexander.Vangelov@vonage.com
* @Date: 2020-07-01 15:56:13
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2023-03-09 21:54:49
*/

const sendReceive = (action, data, callback?) => {
  if (core.dialer) {
    const messageChannel = new MessageChannel();
    const onPortMessage = (msg) => {
      if (msg && typeof(callback) === 'function') {
        callback(msg.data);
      }
      messageChannel.port1.removeEventListener('message', onPortMessage, false);
      messageChannel.port1.close();
    };
    messageChannel.port1.addEventListener('message', onPortMessage, false);
    messageChannel.port1.start();
    core.dialer.frame.contentWindow.postMessage({ action, data }, '*', [messageChannel.port2]);
  }
};

export interface IEntityRef {
  provider: string;
  id: string;
  label?: string;
  type: string;
  typeLabel?: string;
}
export interface IContactableRef extends IEntityRef {
  phoneNumber?: string;
  phoneType?: string;
  extraAttributes?: {[key: string]: any};
  c2d?: boolean;
}
export interface ISdkCore {
  loadPromise?: Promise<any>;
  dialer?: any;
  dot?: any;
  onInteractionEvent?: (interactionEvent: IDialerEvent) => void;
  onSearchContactables?: (q: string, cb?: (contacts: Array<IContactableRef>) => void) => void;
  onOpenContactable?: (contact: IContactableRef) => void;
  sendReceive: any;
};

export const core: ISdkCore = {
  sendReceive
};

export interface IDialerConfigFeatures {
  eventsHistory?: boolean,
  contactsProvider?: boolean,
  openContact?: boolean,
  openActivity?: string
};

export interface IDialerConfigBase {
  mode?: 'dot' | unknown;
  container?: string;
  debug?: boolean;
}

export interface IDialerConfigCC extends IDialerConfigBase {
  provider: 'cc';
  ccDomain?: string;
  ccAccount?: string;
}

export interface IDialerConfigUC extends IDialerConfigBase {
  provider?: 'uc';
  features?: IDialerConfigFeatures
}

export type IDialerConfig = IDialerConfigUC | IDialerConfigCC;

export interface IBaseInteraction {
  id: string;
  uid: string;
  type: string;
  direction: 'INBOUND' | 'OUTBOUND';
  phoneNumber?: string;
  state?: string;
  internal: boolean;
  duration?: number;
  tag?: string;
  did?: string;
  contact?: IContactableRef;
  activity?: IEntityRef;
  vcc?: {[key: string]: any};
}
export interface ICallBase extends IBaseInteraction {
  type: 'CALL';
}
export interface ICallStart extends ICallBase {
  startDate: Date;
}
export interface ICallAnswer extends ICallStart {
  answerDate: Date;
}
export interface ICallEnd extends ICallStart {
  answerDate?: Date;
  endDate: Date;
  duration: number;
}

export interface IChatBase extends IBaseInteraction {
  type: 'CHAT';
}
export interface IChatStart extends IChatBase {
  startDate: Date
}
export interface IChatEnd extends IChatStart {
  endDate: Date
  duration: number;
}

export interface IDialerEventBase {
  type: string;
  data?: any;
}

export interface IDialerEvent_CallStart extends IDialerEventBase {
  type: 'CALL_START';
  data: ICallStart;
}
export interface IDialerEvent_CallAnswer extends IDialerEventBase {
  type: 'CALL_ANSWER';
}
export interface IDialerEvent_CallEnd extends IDialerEventBase {
  type: 'CALL_END' | 'CALL_HISTORY';
}

export interface IDialerEvent_Ready extends IDialerEventBase {
  type: 'READY';
}

export interface IDialerEvent_Logout extends IDialerEventBase {
  type: 'LOGOUT';
}

export interface IDialerEvent_Health extends IDialerEventBase {
  type: 'HEALTH';
  data: boolean;
}

export interface IDialerEvent_SettingsEvent extends IDialerEventBase {
  type: 'SETTINGS_EVENT';
  data: string;
}

export interface IDialerEvent_ScreenPop extends IDialerEventBase {
  type: 'SCREEN_POP';
  data: {
    id: string;
    type: string;
    provider: string;
  };
}

export interface IDialerEvent_ChatStart extends IDialerEventBase {
  type: 'CHAT_START';
  data: IChatStart;
}
export interface IDialerEvent_ChatEnd extends IDialerEventBase {
  type: 'CHAT_END';
  data: IChatEnd;
}

export type IDialerEvent = 
  IDialerEvent_Ready | IDialerEvent_Logout | IDialerEvent_Health | IDialerEvent_ScreenPop | IDialerEvent_SettingsEvent
  | IDialerEvent_CallStart | IDialerEvent_CallAnswer | IDialerEvent_CallEnd
  | IDialerEvent_ChatStart | IDialerEvent_ChatEnd;


